// Narrow selector for the local room player.

import { useContext } from 'react';
import { RoomStateContext } from '../contexts/RoomStateContext';
import { useRoomStoreMyPlayer } from '../contexts/roomStateStore';
import type { RoomPlayer } from '@airhead-games/shared/types';

export function useRoomMyPlayer(): RoomPlayer | null {
  return useRoomStoreMyPlayer();
}

export function useRoomSetMyPlayer(): (player: RoomPlayer | null) => void {
  const context = useContext(RoomStateContext);
  if (!context) {
    throw new Error(
      'useRoomSetMyPlayer must be used within a RoomStateProvider'
    );
  }
  return context.setMyPlayer;
}
